import { FormSection } from "Components/Shared/FormSection";
import { Dropdown } from "Components/Shared/Inputs/Form/Dropdown";
import { FormInput } from "Components/Shared/Inputs/Form/FormInput";
import type { UserValidationType } from "Components/Users/UserDetailPageContent/Components/UserForm";
import { useAdditionalInfoStatusList } from "Hooks/Options/useAdditionalInfoStatusList";
import { useBankVerificationSourceList } from "Hooks/Options/useBankVerificationSourceList";
import { useBankVerificationStatusList } from "Hooks/Options/useBankVerificationStatusList";
import { useIdentityVerificationStatusList } from "Hooks/Options/useIdentityVerificationStatusList";
import { useRiskProfileStatusList } from "Hooks/Options/useRiskProfileStatusList";
import { useUserStatusList } from "Hooks/Options/useUserStatusList";
import { Resources, useResource } from "Translations/Resources";
import type { AccessRoleCode } from "Models/AccessRoleCodes";
import type { Control } from "react-hook-form";

const COMPONENT_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.User.Form;

type UserFormFieldsProps = {
  control: Control<UserValidationType>;
  userType: AccessRoleCode | undefined;
  isBankVerificationDisabled?: boolean;
};

export const UserFormFields = ({
  control,
  userType,
  isBankVerificationDisabled = false,
}: UserFormFieldsProps) => {
  const { t } = useResource();
  const additionalInfoList = useAdditionalInfoStatusList();
  const identityVerificationList = useIdentityVerificationStatusList();
  const riskProfileList = useRiskProfileStatusList();
  const bankVerificationList = useBankVerificationStatusList();
  const bankVerificationSourceList = useBankVerificationSourceList();
  const userStatusList = useUserStatusList(userType);

  return (
    <FormSection>
      <FormInput
        control={control}
        name="login"
        label={t(COMPONENT_RESOURCES.Login)}
      />
      <Dropdown
        name="status"
        label={t(COMPONENT_RESOURCES.Status)}
        codeList={userStatusList}
        control={control}
      />
      <Dropdown
        name="verificationAdditionalInfoStatus"
        label={t(COMPONENT_RESOURCES.VerificationAdditionalInfoStatus)}
        codeList={additionalInfoList}
        control={control}
      />
      <Dropdown
        name="verificationIdentityVerificationStatus"
        label={t(COMPONENT_RESOURCES.VerificationIdentityVerificationStatus)}
        codeList={identityVerificationList}
        control={control}
      />
      <Dropdown
        name="verificationRiskProfile"
        label={t(COMPONENT_RESOURCES.VerificationRiskProfile)}
        codeList={riskProfileList}
        control={control}
      />
      <Dropdown
        name="verificationBankVerificationStatus"
        label={t(COMPONENT_RESOURCES.VerificationBankVerificationStatus)}
        codeList={bankVerificationList}
        control={control}
      />
      <Dropdown
        name="bankVerificationSource"
        label={t(COMPONENT_RESOURCES.BankVerificationSource)}
        codeList={bankVerificationSourceList}
        control={control}
        disabled //readonly
      />
      <FormInput
        name="bankAccountNumber"
        label={t(COMPONENT_RESOURCES.BankAccountNumber)}
        control={control}
        disabled={isBankVerificationDisabled}
      />
      <FormInput
        isNumber
        name="verificationDailyBuyLimit"
        label={t(COMPONENT_RESOURCES.VerificationDailyBuyLimit)}
        disabled={true}
        mask={Number}
        control={control}
      />
      <FormInput
        isNumber
        name="verificationMonthlyBuyLimit"
        label={t(COMPONENT_RESOURCES.VerificationMonthlyBuyLimit)}
        disabled={true}
        mask={Number}
        control={control}
      />
    </FormSection>
  );
};
